export default __webpack_public_path__ + "static/media/117_desktop.8cfafafb.jpg";